import { Card } from '@shazambanking/sdk/components';
import { showErrorNotification } from '@shazambanking/sdk/services/notifications';
import { Form, Formik } from 'formik';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import getInitialNewAccountValues from '../getInitialNewAccountValues';
import Header from './Header';
import { saveNewAccount } from '../api/newAccount';
import NewAccountFormFields from './NewAccountFormFields';
import { NewAccountFormWrapper } from './NewAccountFormWrapper';
import { NewAccountFormValues, NewAccountStartupResource } from '../types';
import { getNewAccountSchema } from './NewAccountValidation';
import { get } from 'lodash';
import { HtmlL10n } from '../../common/HtmlL10n';
import { mapL10nKeys } from '../../common/util/l10n';
import { l10n as naoL10n } from '../l10n/newAccount';

interface Props {
  startupData: NewAccountStartupResource;
}

export default function NewAccountUi(props: RouteComponentProps<any> & Props) {
  const { startupData } = props;
  // njansen 5/13/22 - jankety solution to make l10n work without app bootstrap, this needs called on every page requiring l10n
  const l10n = mapL10nKeys(naoL10n);

  const onSubmit = async (values: NewAccountFormValues) => {
    try {
      const response = await saveNewAccount(values);
      props.history.push({
        pathname: '/confirmation',
        state: {
          values: response,
        }
      });
    } catch (error) {
      showErrorNotification(get(
        error,
        'response.data.message',
        'Server error. Please try again.'
      ));
    }
  };

  return (
    <NewAccountFormWrapper>
      <Header />
      <Card noGutters className="new-account-panel">
        <HtmlL10n l10n={l10n.newAccountInstructions} translate className="new-account-desc" />
        <Formik
          initialValues={getInitialNewAccountValues()}
          onSubmit={onSubmit}
          validationSchema={getNewAccountSchema()}
        >
          <Form name="new-account-form" noValidate>
            <NewAccountFormFields startupData={startupData} />
          </Form>
        </Formik>
      </Card>
    </NewAccountFormWrapper>
  );
};
